<template>
  <div id="app-content">
    <div
      class="menu-w menu-activated-on-hover selected-menu-color-light color-scheme-dark color-style-bright sub-menu-color-bright menu-position-top menu-layout-compact sub-menu-style-over"
    >
      <div class="logo-w" style="width: 160px; margin-right:20px;">
        <a class="logo" href="/" style="width: 150px; height: 34px">
          <img :src="logoUrl()" style="width: 150px; height: 34px;" />
        </a>
      </div>

      <h1 class="menu-page-header">
        {{ $t("portal.page_header") }}
      </h1>

      <div class="logged-user-w avatar-inline" v-if="user">
        <div class="logged-user-i">
          <div class="avatar-w" style="font-size: 1.5em;">
            <i class="os-icon os-icon-user-male-circle2"></i>
          </div>
          <div class="logged-user-info-w">
            <div class="logged-user-name">{{ user && user.email }}</div>
            <div class="logged-user-role">{{ user && user.company }} &#8226; {{ user && user.role }}</div>
          </div>
          <div class="logged-user-toggler-arrow">
            <div class="os-icon os-icon-chevron-down"></div>
          </div>
          <div class="logged-user-menu color-style-bright">
            <div class="logged-user-avatar-info">
              <div class="avatar-w" style="font-size: 1.5em;">
                <i class="os-icon os-icon-user-male-circle2"></i>
              </div>
              <div class="logged-user-info-w">
                <div class="logged-user-name">{{ user && user.email }}</div>
                <div class="logged-user-role">{{ user && user.company }} &#8226; {{ user && user.role }}</div>
              </div>
            </div>
            <div class="bg-icon">
              <i class="os-icon os-icon-user"></i>
            </div>
            <ul>
              <li>
                <a @click="toggleLanguage">
                  <i class="os-icon os-icon-mail-07"></i>
                  <span>{{ $t("portal.change_language") }}</span>
                </a>
                <ul v-if="showLanguage">
                  <li v-for="language in languages" v-bind:key="language.code">
                    <a @click="changeLanguage(language.code)">
                      <i class="os-icon os-icon-arrow-right2"></i>
                      <span>{{ language.name }}</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a @click="logout">
                  <i class="os-icon os-icon-signs-11"></i>
                  <span>{{ $t("portal.logout") }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <h1 class="menu-page-header">
        {{ $t("portal.page_header") }}
      </h1>
      <ul class="main-menu" v-if="user">
        <li v-if="!isUserViewer()">
          <a href="/#/dashboard">
            <div class="icon-w">
              <div class="os-icon os-icon-sidebar"></div>
            </div>
            <span>{{ $t("portal.dashboard") }}</span>
          </a>
        </li>
        <li class="has-sub-menu">
          <a>
            <div class="icon-w">
              <div class="os-icon os-icon-tasks-checked"></div>
            </div>
            <span>{{ $t("general.reports") }}</span>
          </a>
          <div class="sub-menu-w">
            <div class="sub-menu-header">{{ $t("general.reports") }}</div>
            <div class="sub-menu-icon">
              <i class="os-icon os-icon-tasks-checked"></i>
            </div>
            <div class="sub-menu-i">
              <ul class="sub-menu">
                <li v-if="!isUserViewer()">
                  <router-link to="/reports/manage">{{ $t("portal.manage_reports") }} </router-link>
                </li>
                <li v-if="!isUserViewer() && !isUserTester()">
                  <router-link to="/reports/create">{{ $t("portal.create_report") }} </router-link>
                </li>
                <li v-if="!isUserViewer() && !isUserTester()">
                  <router-link to="/reports/search">{{ $t("portal.search_reports") }} </router-link>
                </li>
                <li v-if="!isUserTester()">
                  <router-link to="/reports/view">{{ $t("portal.view_report") }} </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li v-if="!isUserViewer() && !isUserTester()">
          <router-link to="/products">
            <div class="icon-w">
              <div class="os-icon os-icon-delivery-box-2"></div>
            </div>
            <span>{{ $t("general.products") }}</span>
          </router-link>
        </li>

        <li class="has-sub-menu" v-if="isUserAdmin()">
          <a>
            <div class="icon-w">
              <div class="os-icon os-icon-hierarchy-structure-2"></div>
            </div>
            <span>{{ $t("general.base_data") }}</span>
          </a>
          <div class="sub-menu-w">
            <div class="sub-menu-header">{{ $t("general.base_data") }}</div>
            <div class="sub-menu-icon">
              <i class="os-icon os-icon-hierarchy-structure-2"></i>
            </div>
            <div class="sub-menu-i">
              <ul class="sub-menu">
                <li>
                  <router-link to="/characteristics">{{ $t("characteristics.product_characteristics") }} </router-link>
                </li>
                <li>
                  <router-link to="/templates">{{ $t("general.test_template") }} </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li class="has-sub-menu" v-if="isUserAdmin()">
          <a>
            <div class="icon-w">
              <div class="os-icon os-icon-file"></div>
            </div>
            <span>{{ $t("general.administration") }}</span>
          </a>
          <div class="sub-menu-w">
            <div class="sub-menu-header">
              {{ $t("general.administration") }}
            </div>
            <div class="sub-menu-icon">
              <i class="os-icon os-icon-file"></i>
            </div>
            <div class="sub-menu-i">
              <ul class="sub-menu">
                <li>
                  <router-link to="/files/overview">{{ $t("general.files") }} </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div id="router-view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import languages from "@/languages";
import { UserService } from "@/services/UserService";
import { ReportFilterStore } from "@/store/ReportFilterStore";
import { NewReportStore } from "@/store/NewReportStore";

export default {
  name: "Portal",
  data() {
    return {
      user: {},
      showLanguage: false,
      languages: languages.filter(l => l.enabledForUser)
    };
  },
  mounted() {
    this.user = UserService.user;
    ReportFilterStore.setDefaultReportSteps();

    os_init_sub_menus();
  },
  methods: {
    logout() {
      sessionStorage.clear();
      this.$router.push("/login");
      NewReportStore.clearReportStore();
    },
    toggleLanguage() {
      this.showLanguage = !this.showLanguage;
    },
    changeLanguage(code) {
      this.$i18n.locale = code;
      this.showLanguage = false;
      localStorage.setItem("lang", code);
    },
    logoUrl() {
      const hostname = window.location.hostname;
      if (hostname.includes("avvio-cedoon-portal-sta")) {
        return "/svg/logo/logo_white.svg";
      }

      return "/svg/logo/logo_white.svg";
    },
    isUserAdmin: UserService.isUserAdmin,
    isUserTester: UserService.isUserTester,
    isUserViewer: UserService.isUserViewer
  }
};
</script>
